import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useMemo, useState } from "react";
import { useForm} from "react-hook-form";
import * as CONSTANTS from "../../utils/CONSTANTS";
import DropDownListselect from "../../components/dropdown";
import { FormAreaInput } from "../../wrappers/formArea";
import StarRating from '../../components/rating';
import { Icon } from '@iconify/react';
import InfoTooltip from "../../components/infoTooltip";
import classnames from "classnames";
//import {removeDetails} from './services';
import Styles from "./style.module.scss";
import { FormInput } from "../../wrappers/formInput";
const { v4: uuidv4 } = require("uuid");
export type certificationsFormFields = {
  skills: any;
  certificationType: any;

};

interface props {
  onClose?: any;
  ClickHandler?: any;
  defaultValues?: any;
  register?: any;
  key?: any;
  removeId?:any;
  remove?:any;
  subSkillsData?:any;
  SetSubSkillsData?: any;
  loginId?:any;
  errorSubSkillsData?:any;
  errorsubSkillsRatingData?:any;
  setErrorSubSkillsData?:any;
  setErrorSubSkillsRatingData?:any;
  keyidd?:any;
  showValidationMessage?:any;
  errorNoteData?:any;
  setErrorNoteData?:any;
  index?:any;
}

const CertificationForm: React.FC<props> = ({
  onClose,
  ClickHandler,
  defaultValues,
  register,
  key,
  removeId,
  remove,
  subSkillsData,
  SetSubSkillsData,
  loginId,
  errorSubSkillsData,
  errorsubSkillsRatingData,
  setErrorSubSkillsData,
  setErrorSubSkillsRatingData,
  keyidd,
  showValidationMessage,
  index,

}) => {
  const { handleSubmit, control, reset, setValue, formState ,watch} =
    useForm<certificationsFormFields>();
       const [keyid,SetKeyid]=useState<any>(keyidd);
       let valueskillname='';
       let valueskillid='';
       let valueskillRating='';
       let checkskills='Field is Required';
       let checkskillRating='Field is Required';
       let skilldata='';
       let skillRatingData=0;
       if(defaultValues)
       {
       let exit= defaultValues?.[index];
        if (exit !== undefined) {
        valueskillname= defaultValues[index].subSkillName?defaultValues[index].subSkillName:'';
        valueskillid=defaultValues[index].id?defaultValues[index].id:'';
        valueskillRating=defaultValues[index].skillRating?defaultValues[index].skillRating:'';
        checkskills=defaultValues[index].subSkillName ?'':'Field is Required';
        checkskillRating=defaultValues[index].skillRating?'':'Field is Required';   
        skilldata= defaultValues[index].subSkillName;
        skillRatingData=defaultValues[index].skillRating;
        }
       }
     
       const [subSKill, setSubSkill] = useState<any>({id:uuidv4(), subSkillName:valueskillname,skillRating:valueskillRating,key:keyid})
  
       const [errorSkills,SetErrorSkills]=useState<any>(checkskills);
       const [errorSkillRating,SetErrorSkillRating]=useState<any>(checkskillRating);
       
       useEffect(() => {
       if(defaultValues)
       {
        let exit= defaultValues?.[index];
        if (exit !== undefined) {
        if(defaultValues[index].subSkillName=='')
        {
        setErrorSubSkillsData( [...errorSubSkillsData,keyid]);
        }
        if(defaultValues[index].skillRating=='')
        {
        setErrorSubSkillsRatingData( [...errorsubSkillsRatingData,keyid]);
        }
      }
        }
        else
        {
          setErrorSubSkillsData( [...errorSubSkillsData,keyid]);
          setErrorSubSkillsRatingData( [...errorsubSkillsRatingData,keyid]);
        }
      subSkillsData.push(subSKill);
      SetSubSkillsData(subSkillsData);    
      }, [])

      const onremove = (keyid:number) => {
        SetErrorSkills('');
        SetErrorSkillRating('');
        setErrorSubSkillsData( errorSubSkillsData.filter((item: any) => item !== keyid))
        setErrorSubSkillsRatingData( errorsubSkillsRatingData.filter((item: any) => item !== keyid))
        const skilldata: {subSkills:string,skillRating:any,key:any }[]=[];
        subSkillsData.map((newdata:any)=>{
          
          let n=newdata;
        
          if(newdata.key!=keyid)
          {
            skilldata.push(n);
          }
          else
          {
          
          }
          
        });
    
      SetSubSkillsData(skilldata);
      }

  const onChangeskills = (e: any, updateId: number) => {
    
    SetErrorSkills('');
    setErrorSubSkillsData( errorSubSkillsData.filter((item: any) => item !== keyid))
    setSubSkill({...subSKill, subSkillName:e.target.value})
     const n=  subSkillsData.map((item:any) => {
      if (item.key === updateId) {
        return {...subSKill, subSkillName:e.target.value};
      } else {
        return item;
      }
     })
      SetSubSkillsData(n);
  }

  


  const onChangeRating = (e:any,updateId:number) => {

    SetErrorSkillRating('');
    setErrorSubSkillsRatingData( errorsubSkillsRatingData.filter((item: any) => item !== keyid))
    setSubSkill({...subSKill,skillRating:e.value})
     const n=  subSkillsData.map((item:any) => {
      if (item.key === updateId) {
        return{...subSKill,skillRating:e.value};
      } else {
        return item;
      }
    })
      SetSubSkillsData(n);
    }
    
   
  return (
    <>
    <div className={Styles.ratingFormWrap}>
      <div className="form-group mb-0">
        {/* <DropDownListselect
          name="skills"
          data={CONSTANTS.Skills}
          dataItemKey="id"
          textField="name"
          defaultValue={skilldata}
          onChange={(e:any) => onChangeskills(e,keyid)}
          
        /> */}
          <FormInput
            name="skills"
            defaultValue={skilldata}
            onChange={(e: any) => onChangeskills(e,keyid)}
            />
        <div className={Styles.ratingError}> {showValidationMessage?errorSkills:''}</div>
      </div>
      <div className="form-group mb-0">
      <div className={Styles.ratingOption}>
        <div className={Styles.ratingIcons}>
          <StarRating classname="starRatingWrap1" onChange={(e:any) => onChangeRating(e,keyid)}  defaultValue={skillRatingData}/>
          
        </div>
        <div className={Styles.ratingFormAction}>
          <button type='button' className="k-button k-button-md k-button-rectangle k-button-flat k-button-flat-base k-rounded-md  k-icon-button  border-2" onClick={() => {onremove(keyid); remove(removeId); 
          } }>
            <Icon icon="lucide:trash-2" />
          </button>
        </div>
      </div>
      <div className={classnames(Styles.ratingError, Styles.ratingErrorML10)}> {showValidationMessage?errorSkillRating:''}</div>
      </div>
    </div>

    </>
  );
};

export default CertificationForm;
